var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarScheduleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 2.50391V4.17057",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 2.50391V4.17057",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.67057H15.8333",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.3513V5.00382C15.8333 4.08299 15.0875 3.33716 14.1667 3.33716H4.16667C3.24583 3.33716 2.5 4.08299 2.5 5.00382V14.1705C2.5 15.0913 3.24583 15.8372 4.16667 15.8372H10.3475",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83283 8.96224C5.71783 8.96224 5.62449 9.05557 5.62533 9.17057C5.62533 9.28557 5.71866 9.37891 5.83366 9.37891C5.94866 9.37891 6.04199 9.28557 6.04199 9.17057C6.04199 9.05557 5.94866 8.96224 5.83283 8.96224",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83283 12.2955C5.71783 12.2955 5.62449 12.3888 5.62533 12.5038C5.62533 12.6188 5.71866 12.7122 5.83366 12.7122C5.94866 12.7122 6.04199 12.6188 6.04199 12.5038C6.04199 12.3888 5.94866 12.2955 5.83283 12.2955",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95833 9.1714C8.95833 9.2864 9.05167 9.37974 9.16667 9.3789C9.28167 9.3789 9.375 9.28557 9.375 9.17057C9.375 9.05557 9.28167 8.96224 9.16667 8.96224C9.05167 8.96224 8.95833 9.05557 8.95833 9.1714",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3372C11.8658 18.3372 10 16.4722 10 14.1706C10 11.9172 11.9167 10.0014 14.17 10.0039C16.47 10.0056 18.3333 11.8706 18.3333 14.1706C18.3333 16.4714 16.4683 18.3372 14.1667 18.3372",
    stroke: "#001965",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 12.5039V15.8372",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 14.1706H12.5",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarScheduleAdd);
export default __webpack_public_path__ + "static/media/Calendar, Schedule, Add.20e6d449f63d6ee86ba99f700da743dd.svg";
export { ForwardRef as ReactComponent };